import { render, staticRenderFns } from "./BaseProofOrOrderItemListItem.vue?vue&type=template&id=61105b82&scoped=true"
import script from "./BaseProofOrOrderItemListItem.vue?vue&type=script&lang=ts"
export * from "./BaseProofOrOrderItemListItem.vue?vue&type=script&lang=ts"
import style0 from "./BaseProofOrOrderItemListItem.vue?vue&type=style&index=0&id=61105b82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61105b82",
  null
  
)

export default component.exports